<template>
  <div class="container-list">
    <div class="flex">
      <!-- <unitList

       v-show="$store.state.user.company.cCompanyNum==='aaa'"
        @select="getUnit"
        @getFirst="getOne"
      ></unitList> -->
      <div class="flex1">
        <div class="common-page common-head">
          <!-- <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        信息列表
      </div> -->
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar">
            <div class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
            <div class="btn ml10" @click="resetSearch">
              重置
            </div>
            <router-link class="btn ml20" to="/qvyu/video-add"> <i class="icon-tr-newly-added"></i>新增 </router-link>
          </div>
          <div class="common-page common-list">
            <el-table :data="list">
              <el-table-column prop="account" label="摄像头账号" align="center"></el-table-column>
              <el-table-column prop="ip" label="摄像头ip" align="center"></el-table-column>
              <el-table-column prop="account" label="摄像头密码" align="center"></el-table-column>
              <el-table-column prop="channel" label="摄像头通道" align="center"></el-table-column>
              <el-table-column prop="channelName" label="通道名称" align="center"></el-table-column>
              <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>

              <el-table-column prop="updateDate" label="更新时间" align="center"></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-popconfirm title="确定禁用此记录吗？" class="cursor" @confirm="changeStatus(scope.row.ip, 0)" @onConfirm="changeStatus(scope.row.ip, 0)">
                    <a slot="reference" class="red">
                      <el-button type="danger" size="mini" plain>删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="count"></el-pagination>
        </div>
        <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
          <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- {{iframes}} -->
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: "",
      iframes: [],
      showDia: false,
      searchForm: this.$getForm("shexiangsearch"),
      remoteFuncs: {
        getSelect(resolve) {
          post("/devicemanage/mapcode", { mc_parent_id: 215 }).then((res) => {
            resolve(res.data);
          });
        },
      },
      params: { ip: "", type: "" },
      list: [],
      count: 0,
      editData: {},
    };
  },
  created() {
    this.getList();
    this.$get("/camera/api/getLiveIframe", { ip: "192.168.50.100", width: "700", height: "400" }).then((res) => {
      var arr = [];
      arr.push(res.content);
      this.iframes = arr;
      console.log(this.iframes);
    });
  },
  mounted() {},
  watch: {
    //   cpNum(){
    //       this.params.c_company_num = this.cpNum
    //       this.getList()
    //   }
  },
  methods: {
    getList() {
      this.$get("/camera/api/getList", this.params).then((res) => {
        this.list = res.content;
        this.count = res.count;
      });
    },
    changeStatus(ip) {
      this.$get(`/camera/api/remove/`, { ip })
        .then((res) => {
          // this.$message.success("删除成功");
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {},
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };

          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
